// removed by extract-text-webpack-plugin
module.exports = {"cardQuicRead":"cardQuicRead__9IZdp"};


//////////////////
// WEBPACK FOOTER
// ./components/homePageNew/quickReadSection/quickReads.scss
// module id = 501
// module chunks = 68